import React from "react";
import navData from "./navData";
import { createStyles, List, Theme } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LogoutButton from "./LogoutButton";
import { NavData } from "../../models/NavData";
import { useSelector } from "react-redux";
import { State } from "../../store";
import NavButton from "./NavButton";
import LoginButton from "./LoginButton";
import LoginInfo from "./LoginInfo";
import BasketButton from "./BasketButton";
import ChangeFacilityButton from "./ChangeFacilityButton";
import FinalizeButton from "./FinalizeButton";

interface StyleProps {
  fullScreen: boolean;
  width: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: ({ width }: StyleProps) => width,
      minHeight: ({ fullScreen }: StyleProps) => (fullScreen ? "100%" : 0),
      // padding: "0 5%",
      backgroundColor: theme.palette.secondary.main
    },
    listItem: {
      marginTop: 40,
      marginLeft: "5%",
      width: "90%",
      textTransform: "uppercase",
      borderRadius: 10,
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        color: "#3db0e2 !important",
        backgroundColor: "#fff"
      }
    },
    itemText: {
      fontSize: 12,
      fontWeight: "bold",
      "&:hover": {
        color: "#3db0e2 !important"
      }
    }
  })
);

interface IProps {
  width: string;
  pathname: string;
  fullScreen?: boolean;
}

declare const config: { FACILITIES_URL: any[] };

const NavigationList: React.FC<IProps> = ({ width, pathname, fullScreen = false }: IProps) => {
  const classes = useStyles({ width, fullScreen });
  const { isLoggedIn } = useSelector((state: State) => state.auth);
  const conf = useSelector((state: State) => state.config.config);
  const basket = useSelector((state: State) => state.basket.basket);

  return (
    <List className={classes.list}>
      {Object.values(navData(conf)).map((item: NavData, index: number) => (
        <React.Fragment key={index}>
          {item.loginRequired && isLoggedIn && <NavButton item={item} pathname={pathname} />}
          {!item.loginRequired && <NavButton item={item} pathname={pathname} />}
        </React.Fragment>
      ))}

      {isLoggedIn ? (
        <React.Fragment>
          <LogoutButton rootClass={classes.listItem} textClass={classes.itemText} />
          <LoginInfo />
        </React.Fragment>
      ) : (
        <LoginButton rootClass={classes.listItem} textClass={classes.itemText} />
      )}
      <BasketButton />
      {basket.length > 0 && <FinalizeButton rootClass={classes.listItem} textClass={classes.itemText} />}
      {config && config.FACILITIES_URL.length > 0 && (
        <ChangeFacilityButton rootClass={classes.listItem} textClass={classes.itemText} />
      )}
    </List>
  );
};

export default NavigationList;
